import {
  Alert,
  Avatar,
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Paper,
  TextField,
  Typography,
} from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import moment from 'moment'
import DeleteIcon from '@mui/icons-material/Delete'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'
import DetailsBox from '../../../../components/Cards/DetailsBox'
import API from '../../../../services/API'
import { UserContext } from '../../../../App'

const Comments = ({ incident, loadIncident, setIncident }) => {
  const [newComment, setNewComment] = useState('')
  const { user } = useContext(UserContext)

  const handleSubmit = (e) => {
    e.preventDefault()
    API.post('/incident-comment', {
      incidentID: incident._id,
      comment: newComment,
    })
      .then((res) => {
        if (res.status === 200) {
          setIncident((prev) => ({
            ...prev,
            comments: [
              {
                _id: new Date().toISOString(),
                by: {
                  firstName: user.firstName,
                  lastName: user.lastName,
                  photograph: user.photograph,
                },
                createdAt: new Date(),
                comment: newComment,
              },
              ...prev.comments,
            ],
          }))
          setNewComment('')
        }
      })
      .catch((e) => console.log(e))
      .finally(() => setNewComment(''))
  }

  const handleDeleteComment = (commentID) => {
    API.delete(
      `/incident-comment?incidentID=${incident._id}&commentID=${commentID}`,
    )
      .then((res) => res.status === 200 && loadIncident())
      .catch((e) => console.log(e))
  }
  const SingleComment = ({ comment }) => {
    const [anchorEl, setAnchorEl] = useState(null)
    const commentOwner = comment.by?._id === user._id
    const isAdmin =
      user.employee?.teams.includes('Governance') ||
      user?.security?.isSiteAdmin

    return (
      <Box
        display="flex"
        gap={1}
        border="solid 1px #D3D3D3"
        borderRadius={2}
        padding={1}
        sx={{ position: 'relative' }}
        bgcolor="white"
      >
        <Avatar src={comment.by?.photograph} sx={{ width: 24, height: 24 }} />
        <Box display="flex" flexDirection="column">
          <Typography variant="title3" fontSize="0.9rem" lineHeight={1}>
            {comment.by?.firstName} {comment.by?.lastName}
          </Typography>

          <Typography variant="caption">
            {moment(comment.createdAt).format('Do MMM YYYY - HH:mm')}
          </Typography>
          <Typography>{comment.comment}</Typography>
        </Box>
        {(commentOwner || isAdmin) && (
          <Box sx={{ position: 'absolute', top: '5px', right: '5px' }}>
            <IconButton
              sx={{ borderRadius: 2, padding: '2px' }}
              onClick={(e) => setAnchorEl(e.currentTarget)}
            >
              <MoreHorizIcon color="primary" />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={!!anchorEl}
              onClose={() => setAnchorEl(null)}
            >
              <MenuItem onClick={() => handleDeleteComment(comment._id)}>
                Delete
              </MenuItem>
            </Menu>
          </Box>
        )}
      </Box>
    )
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={1}
      minHeight="100%"
      width="100%"
      overflow="auto"
      justifyContent="stretch"
      padding={1}
    >
      <Box
        display="flex"
        flexDirection="column"
        flex={1}
        gap={1}
        maxHeight={300}
        overflow="auto"
      >
        {incident.comments
          ?.sort((a, b) => (a.createdAt > b.createdAt ? -1 : 1))
          .map((comment) => (
            <SingleComment comment={comment} key={comment._id} />
          ))}
      </Box>
      <Box
        component="form"
        onSubmit={handleSubmit}
        marginTop="2rem"
        bgcolor="white"
        padding={1}
      >
        <TextField
          value={newComment}
          onChange={(e) => setNewComment(e.target.value)}
          placeholder="Add a Comment..."
          size="small"
          fullWidth
          multiline
          required
        />
        <Button
          type="submit"
          fullWidth
          color="primary"
          variant="contained"
          size="small"
          sx={{ marginTop: 1 }}
        >
          Submit
        </Button>
      </Box>
    </Box>
  )
}

export default Comments
